import { Content } from "@pathwright/ui/src/components/content/Content"
import styled from "styled-components"

export const ImageText = styled.div`
  width: 50%;
  color: #fff;
`

// export const TextBackgroundImageContainer = styled.div`
// 	position: relative;
// 	display: flex;
// 	flex-wrap: wrap;
// 	width: 100%;
// 	min-height: 400px;
// 	align-items: center;
// `

export const TextBackgroundWrapper = styled.div`
  width: 100%;
  position: relative;
  /* overflow: hidden; */
  overflow: visible; /* necessary to allow editor to display outside block */
  padding: 100px 0;

  /* apply blocks styles colors */
  & > p,
  .ql-editor,
  .ql-editor > *,
  .ql-editor p,
  .BlockText,
  .BlockText > *,
  .BlockText p,
  .ContentText,
  .ContentText.ql-editor,
  .ContentText.ql-editor .BlockText,
  .ContentText.ql-editor .BlockText p {
    // Ignore block styles colors
    color: ${(p) => (p.textColor ? `${p.textColor}!important` : "")};
  }
`

export const ContentRow = styled(Content.Container)`
  display: flex;
  /* flex-wrap: nowrap; */
  align-items: flex-start;

  @media (max-width: 750px) {
    flex-direction: column;
  }
`

export const Col = styled.div`
  width: 50%;
  @media (max-width: 750px) {
    width: 100%;
  }
`

export const AutoWidthCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > div {
    text-align: center;

    @media (min-width: 751px) {
      text-align: right;
    }
  }

  .BlockImage {
    width: auto;
    display: inline-block;
  }

  img {
    width: auto;
    /* Min width allows replace image button to appear on small images */
    min-width: 150px;
    max-width: 100%;
  }
`
